module.exports = __webpack_public_path__ + "img/Fromagerie.6afa3f4d.jpg";